import React from 'react';
import { Menu, Bell } from 'lucide-react';

export default function AdminHeader({ user, onMenuToggle }) {
  return (
    <header className="sticky top-0 z-30 bg-[#264D59]">
      <div className="flex items-center justify-between h-20 px-4 lg:px-6">
        <button onClick={onMenuToggle} className="lg:hidden p-2 rounded-lg text-white/60 hover:text-white hover:bg-white/10 transition-colors"><Menu size={22} /></button>
        <div className="hidden lg:block" />
        <div className="flex items-center gap-4">
          <button className="relative p-2 rounded-lg text-white/60 hover:text-white hover:bg-white/10 transition-colors">
            <Bell size={20} /><span className="absolute top-1.5 right-1.5 w-2 h-2 bg-[#F9E07F] rounded-full" />
          </button>
          <div className="flex items-center gap-3 pl-4 border-l border-white/10">
            <div className="w-9 h-9 bg-[#F9E07F] rounded-full flex items-center justify-center text-[#264D59] text-sm font-bold">
              {user?.name?.charAt(0)?.toUpperCase() || 'A'}
            </div>
            <div className="hidden sm:block">
              <p className="text-sm font-medium text-white">{user?.name || 'Admin'}</p>
              <p className="text-xs text-white/60">{user?.email || 'admin@example.com'}</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
